'use client';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

export const BaseTabs = styled(Tabs)();
export const BaseTab = styled(Tab)();
